import React, { useEffect, useState } from "react";
import "./createNewQuery.css";
import Form from "react-bootstrap/Form";
import axios from "../../../../axios";
import { useLocation } from "react-router-dom";
import Select from "react-select";
import CrossQueryAttachment from "./CrossQueryAttachment";
import moment from "moment";
import assets from "../../../../assets/assets";
import { toast } from "react-toastify";

const CreateNewQuery = ({
  socket,
  editQueryData,
  setEditQueryData,
  groupData,
  change,
  headerChange,
  handleRefresh,
  setActiveHeader,
}) => {
  let teacher_id = JSON.parse(localStorage.getItem("Teacher_id"));
  const timeTableSessionId = JSON.parse(
    localStorage.getItem("timeTableSessionId")
  );
  const [isValidFileType, setIsValidFileType] = useState(true);
  const [queryTopicList, setQueryTopicList] = useState([]);
  const [isInProgress, setIsInProgress] = useState(false);
  const [tagLimit, setTagLimit] = useState(false);
  const [attach, setAttach] = useState(
    editQueryData?.attachments?.length > 0 ? editQueryData?.attachments : []
  );
  const [sizeInMb, setSizeMb] = useState(0);
  const [attachMent2, setAttachment2] = useState([]);

  // editQueryData?.attachments?.length > 0 && true;
  let sectionId = groupData?.section?.id;
  let standardId = groupData?.standard?.id;
  let subjectId = groupData?.subject?.id;

  //Added this state by kuldeep
  const { state } = useLocation();

  const [bookChapter, setBookChapter] = useState({
    chapters: [],
  });
  const { chapters } = bookChapter;
  console.log(chapters, "chapters");
  const [queryData, setQueryData] = useState({
    query: editQueryData.query ? editQueryData.query : "",
    description: editQueryData.description ? editQueryData.description : "",
    tags: editQueryData.tags ? editQueryData.tags : [],
    bookId: editQueryData.book?.id ? editQueryData.book.id : "",
    chapterId: editQueryData.chapter?.id ? editQueryData.chapter.id : "",
  });
  const { query, description, tags, bookId, chapterId } = queryData;
  console.log(editQueryData?.attachments_sizeKb, "tyt");
  const handleClick = () => {
    change(false);
    headerChange(false);
    setEditQueryData({});
  };

  const handleInputChange = (inputValue) => {
    if (inputValue.length > 20) {
      inputValue = inputValue.substring(0, 20);
      setTagLimit(true);
    } else {
      setTagLimit(false);
    }
    setQueryTopicList((prev) => [
      ...prev,
      { value: inputValue, label: inputValue },
    ]);
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    // Check if the input value contains non-space characters
    if (value.trim() !== "" || value === "") {
      setQueryData((queryData) => ({
        ...queryData,
        [name]: value,
      }));
    }
  };

  const getData = async () => {
    try {
      let book = await axios.get(
        `/api/v1/cm/library/book/getBookByClassSectionSubject?standard_id=${standardId}&section_id=${sectionId}&subject_id=${subjectId}&timetableSessionId=${timeTableSessionId}`
      );

      book &&
        setBookChapter({
          ...bookChapter,
          chapters: book.data.data,
        });
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getData();
  }, [standardId, sectionId, subjectId]);

  useEffect(() => {
    const getTags = async () => {
      try {
        let tags = await axios.get(`/api/v1/query/tags/get`);
        let tagList = tags?.data?.data?.map((tag) => {
          return { label: tag, value: tag };
        });
        tagList.length > 0 && setQueryTopicList(tagList);
      } catch (error) {
        console.log(error);
      }
    };
    getTags();
  }, []);

  const handleSubmit = async (e) => {
    setIsInProgress(true);
    e.preventDefault();
    // console.log(tags);
    // let topic = tags.length > 1 ? tags.split(",") : tags;
    let newQuery = {
      user_id: teacher_id,
      query,
      group_id: editQueryData?.group,
      description,
      tags: tags,
      attachments_sizeKb: Math.round(
        attachMent2.map((file) => file.size / 1024)
      ),
      book_id: bookId,
      chapter_id: chapterId,
      attachments: attach,
      status: "approved",
    };
    try {
      let res;
      Object.keys(editQueryData).length > 0
        ? (res = await axios.put(
            `/api/v1/query/update/${editQueryData.id}`,
            newQuery
          ))
        : (res = await axios.post(
            `/api/v1/query/create/groupId/${state.groupId}`,
            newQuery
          ));
      if (res) {
        setEditQueryData({});
        handleRefresh();
        toast.success(res.data.message);
        setActiveHeader("all");
        change(false);
      }
    } catch (error) {
      setIsInProgress(false);
      console.log(error);
    }
  };
  let totalSize;
  const handleAttachment = async (files, e) => {
    let attachments = [];
    let totalSizeInBytes = attachMent2.reduce(
      (acc, file) => acc + file.size,
      0
    );
    let fileCount = attach.length;
    const previousSizesInBytes = (editQueryData?.attachments_sizeKb || []).map(
      (sizeInKB) => sizeInKB * 1024
    );
    const previousTotalSizeInBytes = previousSizesInBytes.reduce(
      (acc, size) => acc + size,
      0
    );
    totalSize = totalSizeInBytes + previousTotalSizeInBytes;

    if (files) {
      for (const file of files) {
        if (
          fileCount < 5 &&
          totalSize + file.size <= 10 * 1024 * 1024 &&
          validateFileType(file)
        ) {
          try {
            const maxSizeInMB = file.type.startsWith("image")
              ? 10
              : file.type === "audio/mpeg"
              ? 10
              : 10;
            const maxSizeInBytes = maxSizeInMB * 1024 * 1024;
            if (file.size > maxSizeInBytes) {
              window.alert(
                `File size exceeds ${maxSizeInMB} MB for ${file.name}.`
              );
              continue;
            }
            let formData = new FormData();
            formData.append("name", file.name);
            formData.append("uploadReplyAttachment", file);

            let res = await axios.post(
              `/api/v1/reply/uploadAttachment/userId/${teacher_id}`,
              formData
            );
            res && attachments.push(res.data.data);
            setAttachment2((prev) => [...prev, file]);
            totalSize += file.size;
            fileCount += 1;
          } catch (error) {
            console.log(error);
            toast.error(error.response.data.message);
          }
        } else {
          // window.alert(`File validation failed for ${file.name}.`);
          setIsValidFileType(false);
        }
      }

      if (attachments.length > 0) {
        setAttach((prev) => [...prev, ...attachments]);
      }
    }
    e.target.value = "";
  };
  const validateFileType = (filePath) => {
    var allowedExtensions =
      /(\.jpg|\.jpeg|\.png|\.pdf|\.ppt|\.pptx|\.mp3|\.mp4)$/i;

    if (!allowedExtensions.exec(filePath.name) || attach.length > 5) {
      setIsValidFileType(false);
      return false;
    }
    setIsValidFileType(true);
    return true;
  };

  const timeHelper = (a) => {
    const dateObj = new Date(a);
    dateObj.setUTCMinutes(dateObj.getUTCMinutes() + 330); // Add 5 hours and 30 minutes

    const day = dateObj.getUTCDate();
    const month = dateObj.getUTCMonth() + 1;
    const year = dateObj.getUTCFullYear();
    const hours = dateObj.getUTCHours();
    const minutes = dateObj.getUTCMinutes();
    const seconds = dateObj.getUTCSeconds();

    const outputDateString = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    return outputDateString;
  };
  const MAX_CHARACTERS = 150;
  return (
    <>
      <>
        <div
          className="  d-flex align-items-center justify-content-between create_query_box_header px-4 "
          style={{
            backgroundColor: "#ffebd3",
            height: "60px",
          }}
        >
          {Object.keys(editQueryData).length > 0 ? (
            <div className="d-flex flex-column">
              <span className="threade_header">Edit Query</span>
              <span className="query_last_modified">
                Last Modified : &nbsp;
                {moment(timeHelper(editQueryData?.updated_at)).format(
                  "hh:mm A"
                )}
                &nbsp; | &nbsp;
                {moment(timeHelper(editQueryData?.updated_at)).format(
                  "MMM DD, YYYY "
                )}
              </span>
            </div>
          ) : (
            <span className="threade_header poppins-semibold">
              Create new thread
            </span>
          )}
          <img
            src="/images/cross-circle3.svg"
            className="create_thread_close_btn"
            alt=""
            onClick={handleClick}
          />
        </div>
        <div className="px-4 h-100 py-3">
          <form onSubmit={handleSubmit}>
            <div className="mt-3">
              {tagLimit && (
                <p className="SpclStyle">
                  Tag length exceeded, please enter a tag less than 20
                  Characters.
                </p>
              )}
              <div className="mt-4 addTopic">
                <Select
                  style={{ width: "100%", border: "none" }}
                  placeholder="⊕ Add Topic*"
                  options={queryData.tags.length >= 3 ? [] : queryTopicList}
                  isMulti
                  maxLength={20}
                  className="w-100"
                  defaultValue={
                    tags.length > 0 &&
                    tags.map((tag) => ({
                      value: tag,
                      label: tag,
                    }))
                  }
                  onChange={(selectedOptions) => {
                    const selectedValues = selectedOptions.map(
                      (option) => option.value
                    );
                    setQueryData({ ...queryData, tags: selectedValues });
                  }}
                  onInputChange={(e) => handleInputChange(e)}
                  styles={{
                    placeholder: (provided) => ({
                      ...provided,
                      color: "#555", // ✅ Darker placeholder
                      fontWeight: 500,
                    }),
                    menu: (provided) => ({
                      ...provided,
                      marginTop: "0",
                      borderTop: "none",
                    }),
                  }}
                />
              </div>
            </div>
            <div className="mt -3">
              <select
                className={
                  chapterId
                    ? " mt-3 form-select by"
                    : " mt-3 form-select bello1"
                }
                onChange={(e) =>
                  setQueryData({
                    ...queryData,
                    bookId:
                      e.target.options[e.target.selectedIndex].getAttribute(
                        "book-id"
                      ),
                    chapterId: e.target.value,
                  })
                }
                value={chapterId}
              >
                <option value="">Select Chapter*</option>
                {chapters?.length > 0 &&
                  chapters?.map((item) =>
                    item.bookInfo.map((book) => (
                      <optgroup
                        label={book.name}
                        key={book.id}
                        book-id={book.id}
                      >
                        {book.chapterData.map((chapter) => (
                          <option
                            key={chapter.id}
                            book-id={book.id}
                            book-name={book.name}
                            value={chapter.id}
                          >
                            {chapter.chapterName}
                          </option>
                        ))}
                      </optgroup>
                    ))
                  )}
              </select>
            </div>
            <div className="mt-3">
              <Form.Control
                type="text"
                placeholder="Add Query Tittle*"
                className={queryData.query ? "" : " form-control bello1 py-2"}
                value={queryData.query}
                name="query"
                onChange={handleChange}
                maxLength={150}
              />
            </div>
            <textarea
              type="text"
              placeholder="Query Description*"
              className={
                queryData.description
                  ? "w-100 mt-3 query_attach descHght form-control "
                  : "w-100 mt-3 query_attach descHght form-control bello1"
              }
              value={queryData.description}
              rows="5"
              name="description"
              onChange={handleChange}
              maxLength={500}
              style={{ fontSize: "15px" }}
            />
            <div className="mt-3 me-3 gap-3 d-flex align-items-center justify-content-end query_attach_btn">
              <div className="mb-3  attachCont ">
                {attach.length > 0 &&
                  attach.map((item, index) => (
                    <CrossQueryAttachment
                      key={index}
                      indexToRemove={index}
                      setAttachment2={setAttachment2}
                      attachMent2={attachMent2}
                      attachment={item}
                      setAttach={setAttach}
                    />
                  ))}
              </div>
              <input
                id="attachFile"
                type="file"
                multiple
                style={{ display: "none" }}
                onChange={(e) => handleAttachment(e.target.files, e)}
              />
              <label
                htmlFor={`attachFile`}
                style={{
                  border: "1px solid #8D4B28",
                  color: "#8D4B28",
                  backgroundColor: "white",
                }}
                className="rounded-3 mt-2 p-1 d-flex align-items-center justify-content-center poppins-semibold "
              >
                <img
                  src={assets.UploadIcon}
                  height="70%"
                  width="25px"
                  alt="Attach Icon"
                  style={{
                    objectFit: "contain",
                    maxHeight: "100%",
                  }}
                />
              </label>
              {Object.keys(editQueryData).length > 0 ? (
                <button type="submit" className="btn btn-danger px-4 post_btn1">
                  Update
                </button>
              ) : (
                <button
                  disabled={
                    !query ||
                    !description ||
                    queryData.tags.length === 0 ||
                    !chapterId ||
                    isInProgress
                  }
                  type="submit"
                  className="btn btn-danger px-4 post_btn1"
                >
                  Publish
                </button>
              )}
            </div>
          </form>
        </div>
        {!isValidFileType && (
          <p id="errorMsg">
            Please upload a file with a valid extension (JPG, JPEG, PNG, PDF,
            PPT,PPTX,MP3,MP4) , Max Limit = 5 and file size should be less then
            10MB.
          </p>
        )}
      </>
    </>
  );
};

export default CreateNewQuery;
